var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('h2',{staticClass:"message mb-2"},[_vm._v("Page Not Found")]),_c('img',{staticClass:"image invert-on-darkmode mt-4",attrs:{"src":require("@/assets/404.png")}})])
}]

export { render, staticRenderFns }